import { useQuery } from "@tanstack/react-query";
import { EntityValue, emptyPage, Page } from "@/model";
import entityValueRepository from "@/repository/entityValueRepository";


const getData = async (
    agentId: number,
    entityId: string,
    page: number,
    size: number,
    keyword?: string
) => {
    const res = await entityValueRepository.find(agentId, entityId, page, size, keyword);
    return res.data?.data || emptyPage<EntityValue>();
};

export const usePaginatedEntityValue = (
    agentId: number,
    entityId: string,
    page: number,
    size: number,
    keyword?: string) => {
    return useQuery<Page<EntityValue>>({
        queryKey: ['page-entity-values', 'agent', agentId, 'entity', entityId, 'page', page, 'size', size, 'keyword', keyword],
        queryFn: async () => getData(agentId, entityId, page, size, keyword),
        retry: false
    });
};